import RouterUtils from '@/utils/router';
import EventCourse from '@/views/event/EventCourse.vue';
import EventHome from '@/views/event/EventHome.vue';
import TypeHome from '@/views/event/EventTypeHome.vue';

export default [
  {
    path: '/events',
    name: 'eventHome',
    component: EventHome,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      () => {
        RouterUtils.markCurrentFunction({
          key: 'professional-development',
          name: 'Professional Development',
        });
      },
      () => {
        RouterUtils.markLevelUp({ name: 'dashboard' });
      },
    ],
  },
  {
    path: '/type-events/:typecode',
    name: 'typeEvents',
    component: TypeHome,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      () => {
        RouterUtils.markCurrentFunction({
          key: 'professional-development',
          name: 'Professional Development',
        });
      },
      () => {
        RouterUtils.markLevelUp({ name: 'eventHome' });
      },
    ],
    props: true,
  },
  {
    path: '/event-course/:eventId',
    name: 'course',
    component: EventCourse,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      () => {
        RouterUtils.markCurrentFunction({
          key: 'professional-development',
          name: 'Professional Development',
        });
      },
      () => {
        RouterUtils.markLevelUp({ name: 'eventHome' });
      },
    ],
    props: true,
  },
  {
    path: '/type-event-course/:typecode/:eventId',
    name: 'typeEventCourse',
    component: EventCourse,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      () => {
        RouterUtils.markCurrentFunction({
          key: 'professional-development',
          name: 'Professional Development',
        });
      },
      (to) => {
        RouterUtils.markLevelUp({ name: 'typeEvents', params: { typecode: to.params.typecode } });
      },
    ],
    props: true,
  },
];
